import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { AdminAccountListItemActions } from "../../AdminAccountsList/AdminAccountsListItem/AdminAccountsListItem";
import "./AdminUsersListItem.css";

export const AdminUsersListItem = ({ user }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [hasMouseOver, setHasMouseOver] = useState(false);

  return (
    <div
      className="AdminUsersListItem"
      onMouseEnter={() => setHasMouseOver(true)}
      onMouseLeave={() => setHasMouseOver(false)}
    >
      <div className="AdminAccountsListItem__name">
        {user.name ? user.name : " - "}
      </div>
      <div className="AdminUsersListItem__email">{user.email}</div>
      <div className="AdminAccountsListItem__status">
        <div
          className="AdminAccountsListItem__status--indicator"
          style={{
            backgroundColor: user.status === "ACTIVE" ? "#56B267" : "#D69D23",
          }}
        ></div>
        <div className="AdminAccountsListItem__status--text">
          {t(user?.status?.toLowerCase())}
        </div>
      </div>

      <div className="UserAccountUsers__user--actions">
        <AdminAccountListItemActions
          location={location}
          id={user.id}
          mouseOver={hasMouseOver}
          listActions={listActions}
        />
      </div>
    </div>
  );
};

const listActions = [
  {
    action: "edit-user",
    label: "settings.editUser",
    link: "manage",
  },
];
